export default {
  dbi_no_translate_pcu: 'PCU',
  dbi_no_translate_mscience: 'Mscience',
  dbi_no_translate_npd: 'NPD',
  dbi_no_translate_user_engagement: 'User Engagement',
  dbi_no_translate_gsd: 'GSD',
  dbi_no_translate_streaming: 'Streaming',
  dbi_no_translate_steam_sales: 'Steam Sales',
  dbi_no_translate_steam_vginsights: 'VGInsights',
  dbi_no_translate_famitsu: 'Famitsu',
  dbi_no_translate_steam_data: 'Steam Data',
  dbi_no_translate_no_update: 'No-Update',
  dbi_no_translate_ampere: 'Other Vendor',
  dbi_no_translate_alinea_analytics: 'Alinea Analytics',
  dbi_no_translate_mobile_metrics: 'Mobile Metrics',
  dbi_no_translate_pc_metrics: 'PC Metrics',
  dbi_no_translate_console_metrics: 'Console Metrics',
  dbi_no_translate_game_owned: 'Games Owned',
};
